document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[name="admin_subordinates_search"]');
  if (form) {
    const orderRoleSelect = document.querySelector(
      '#admin_subordinates_search_role'
    );
    const orderNameSelect = document.querySelector(
      '[name="admin_subordinates_search[orderBy]"]'
    );

    let orderOffset = document.getElementById(
      'admin_subordinates_search_offset'
    );

    orderRoleSelect.addEventListener('change', function () {
      removeParam('admin_subordinates_search[offset]');
      orderOffset.value = 0;
      orderRoleSelect.form.submit();
    });

    orderNameSelect.addEventListener('change', function () {
      removeParam('admin_subordinates_search[offset]');
      orderOffset.value = 0;
      orderNameSelect.form.submit();
    });
  }
});

function removeParam(parameter) {
  var url = document.location.href;
  var urlparts = url.split('?');

  if (urlparts.length >= 2) {
    var urlBase = urlparts.shift();
    var queryString = urlparts.join('?');

    var prefix = encodeURIComponent(parameter) + '=';
    var pars = queryString.split(/[&;]/g);
    for (var i = pars.length; i-- > 0; )
      if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);
    url = urlBase + '?' + pars.join('&');
    window.history.replaceState('', document.title, url); // added this line to push the new url directly to url bar .
  }
  return url;
}
